import config from 'constants/config'
import { CompactFooter, OriginalFooter } from 'components/App/Footer'
import MinimalFooter from '../Footer/MinimalFooter'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import { useAppSelector } from 'hooks/reduxHooks'
import styled from 'styled-components'
import { rem } from 'polished'
import { useLocation } from 'react-router-dom'
import { matchLocaleAwarePath } from 'lib/routing/matchLocaleAwarePath'
import {
  routesWithMinimalFooter,
  routesWithNoFooter,
  routesWithNoFooterMobileTablet,
} from './footerRouteConfig'

const ReservedFooterSpace = styled.div`
  /*
      Place space at the bottom to simulate some footer spacing
      This prevents overflow issues where by absolutely positioned elements
      at the bottom of the page MAY overflow the page and a cause a second scrollbar
      Now there is no way to overflow, as there is extra padding.
    */
  height: ${rem(40)};
`

function FooterRoutes() {
  const headless = useAppSelector(state => state.system.headlessMode)
  const location = useLocation()
  const pathname = location.pathname

  const Footer = config.footer.type === 'original' ? OriginalFooter : CompactFooter

  if (matchLocaleAwarePath(pathname, { path: routesWithNoFooter })) {
    return null
  }

  if (matchLocaleAwarePath(pathname, { path: routesWithMinimalFooter })) {
    return <MinimalFooter />
  }

  if (matchLocaleAwarePath(pathname, { path: routesWithNoFooterMobileTablet })) {
    return <CSSBreakpoint min="desktop">
      <Footer />
    </CSSBreakpoint>
  }

  if (matchLocaleAwarePath(pathname, { path: '/:regionCode/', exact: true })) {
    return <Footer />
  }

  return <>
    {headless && <ReservedFooterSpace aria-hidden="true" />}
    {!headless && <Footer />}
  </>
}

export default FooterRoutes
